import * as React from 'react';
import * as Scroll from 'react-scroll';
import translate from '../../locale/translate';

import * as WidgetComponents from '../widget';
import WidgetEditWrapper from './WidgetEditWrapper';
import ReportPropsForm from '../reportProperties/FormContainer';

import { Widget } from '../../store/models';
import { arrayMove } from '../widget/util/ArrayUtil';

interface IWidgetCanvasProps {
    widgets: Widget[],
    widgetIdInEditor: string,
    onEdit: Function,
    onDelete: Function,
    onSaveAll: Function
};

export default class WidgetCanvas extends React.Component<IWidgetCanvasProps, void> {
    static propTypes = {
        widgets: React.PropTypes.array.isRequired,
        widgetIdInEditor: React.PropTypes.string,
        onEdit: React.PropTypes.func.isRequired,
        onDelete: React.PropTypes.func.isRequired,
        onSaveAll: React.PropTypes.func.isRequired
    };

    scroll = Scroll.animateScroll;

    onSortEnd(widget: Widget, direction: number) {
        const oldIdx = this.props.widgets.indexOf(widget);
        let newIdx = oldIdx + direction;

        if (newIdx < 0) {
            newIdx = 0;
        }

        this.props.onSaveAll(arrayMove(this.props.widgets, oldIdx, newIdx));
    }

    performScroll(widgets: Widget[], nextWidgets: Widget[]) {
        if (widgets.length < nextWidgets.length) {
            this.scroll.scrollToBottom();
        } else if (widgets.length > nextWidgets.length) {
            this.scroll.scrollToTop();
        }
    }

    componentDidUpdate(prevProps) {
        const prevWidgets = prevProps.widgets;
        const { widgets } = this.props;

        this.performScroll(prevWidgets, widgets);
    }

    getUpButton(widget: Widget, isFirst: boolean) {
        let commonCls = 'btn btn-link btn-xs'

        if (isFirst) {
            commonCls += ' disabled';
        }

        return <a key="up" className={commonCls} onClick={() => this.onSortEnd(widget, -1)}><i className="fa fa-arrow-up" /></a>;
    }

    getDownButton(widget: Widget, isLast: boolean) {
        let commonCls = 'btn btn-link btn-xs'

        if (isLast) {
            commonCls += ' disabled';
        }

        return <a key="down" className={commonCls} onClick={() => this.onSortEnd(widget, 1)}><i className="fa fa-arrow-down" /></a>;
    }

    renderWidget(widget: Widget, widgetIdInEditor: string, isFirst: boolean, isLast: boolean) {
        let Ele;
        const WidgetComponent = WidgetComponents.getByName(widget.type);

        if (WidgetComponent) {
            Ele = <WidgetComponent.WidgetContainer widgetId={widget.id} />;
        } else {
            console.warn(`${widget.type} is an unknown widget type`);
        }

        if (!Ele) {
            console.warn(`${widget.type} has no WidgetContainer`);
            return null;
        }

        const buttons = [
            <a key="delete" className="btn btn-link btn-xs" onClick={() => this.props.onDelete(widget)}><span className="fa fa-trash"></span></a>,
            <a key="edit" className="btn btn-link btn-xs" onClick={() => this.props.onEdit(widget)}>{translate.gettext("Edit")}</a>,
            this.getUpButton(widget, isFirst),
            this.getDownButton(widget, isLast),
        ];

        return (
            <WidgetEditWrapper
                key={widget.id}
                widget={widget}
                selected={widgetIdInEditor === widget.id}
                buttons={buttons}
            >
                {Ele}
            </WidgetEditWrapper>
        );
    }

    render() {
        const { widgets } = this.props;

        if (widgets.length) {
            return (
                <div>
                    <div className="panel panel-default">
                        <div className="panel-body">
                            <ReportPropsForm />
                        </div>
                    </div>

                    {widgets.map((widget, idx) => {
                        return this.renderWidget(widget, this.props.widgetIdInEditor, idx <= 0, idx >= widgets.length - 1);
                    })}
                </div>
            );
        }

        return (
            <div className="jumbotron">
                <h1>{translate.gettext("This is your report canvas.")}</h1>
                <p>{translate.gettext("Choose components from the menu to create your custom report.")}</p>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widgetCanvas/WidgetCanvas.tsx